import React from 'react';
import { Link } from 'react-router-dom';

import { TitleCenter, BackLink } from '../styles';

const InvalidToken = () => (
  <>
    <TitleCenter>
      Your reset password link is invalid or expired.
    </TitleCenter>

    <BackLink>
      <Link to="/">Sign into PlaybookUX</Link>
    </BackLink>
  </>
);

export default InvalidToken;
